<div class="clearfix"></div>

<!-- Title Header Start -->
<section class="inner-header-title" style="background-image:url(assets/img/bn2.jpg);  ">
    <div class="container">
        <h3>Forgot Password</h3>
    </div>
</section>
<div class="clearfix"></div>
<!-- Title Header End -->

<!-- Tab Section Start -->
<section class="tab-sec gray">
    <div class="container">
        <div class="col-lg-8 col-md-8 col-sm-12 col-lg-offset-2 col-md-offset-2">
            <div class="new-logwrap">

                <div class="tab-content">

                    <div id="candidate" class="tab-pane fade in active">


                        <div class="form-group">
                            <label>Mobile Number</label>
                            <div class="input-with-icon">
                                <input type="email" [(ngModel)]="phoneNumber" class="form-control"
                                    placeholder="Enter Your Mobile Number">
                                <i class="theme-cl ti-email"></i>
                            </div>
                        </div>

                        <!-- <div class="form-group">
                            <label>Password</label>
                            <div class="input-with-icon">
                                <input type="password" [(ngModel)]="password" class="form-control" placeholder="Enter Your Password">
                                <i class="theme-cl ti-lock"></i>
                            </div>
                        </div> -->


                        <div class="form-groups">
                            <button type="submit" (click)="forgotPassword()"
                                class="btn btn-primary full-width">Submit</button>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>
</section>
<!-- Tab section End -->